import React, { useEffect, useRef, useState } from "react";
import { MdCloudUpload } from "react-icons/md";
import { PRIMARY } from "../../utils/colors";
import './FilePicker.css';
import { IoMdClose } from "react-icons/io";
import { STORAGE_URL } from "../../utils/constants";
import { useTranslation } from "react-i18next";

function FilePicker({ onChange, images = [], onRemove, uploadLoading, uploadLength, resetKey }) {
  const { t } = useTranslation();
  const [files, setFiles] = useState([]); // { file, preview, isVideo }
  const inputRef = useRef();
  const createdUrlsRef = useRef([]);

  useEffect(() => {
    onChange(files.map(f => f.file));
  }, [files]);

  // Cleanup all created object URLs on unmount
  useEffect(() => {
    return () => {
      createdUrlsRef.current.forEach(url => {
        try { URL.revokeObjectURL(url); } catch (e) {}
      });
      createdUrlsRef.current = [];
    };
  }, []);

  useEffect(() => {
    if (resetKey === undefined) return;

    createdUrlsRef.current.forEach(url => {
      try { URL.revokeObjectURL(url); } catch (e) {}
    });

    createdUrlsRef.current = [];
    setFiles([]);
    if(inputRef.current) inputRef.current.value = "";
  }, [resetKey]);

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files || []);
    if (selectedFiles.length === 0) return;

    const mappedFiles = selectedFiles.map(file => {
      const preview = URL.createObjectURL(file);
      createdUrlsRef.current.push(preview);
      return {
        file,
        preview,
        isVideo: file.type.startsWith("video/")
      };
    });

    setFiles(prev => [...prev, ...mappedFiles]);

    // Reset input so same file can be re-selected if needed
    event.target.value = "";
  };

  const triggerFileInput = () => {
    inputRef.current.click();
  };

  return (
    <>
      <div className="text-center file-picker-container pt-2" onClick={triggerFileInput} role="button">
        <input
          type="file"
          className="d-none"
          ref={inputRef}
          multiple
          accept="image/*,video/*"
          onChange={handleFileChange}
        />
        <MdCloudUpload size={100} color={PRIMARY} className="mb-2" />
        <p className="small text-primary">{t('create_property.fields.images.placeholder')}</p>
      </div>

      <div className="d-flex file-picker-files mt-2 flex-wrap">
        {uploadLoading && Array.from({ length: uploadLength }).map((_, idx) => (
          <div className="file-picker-files-preview me-2 mb-2 d-flex align-items-center justify-content-center border" key={idx} style={{ width: 94, height: 94, backgroundColor: '#f0f0f0', borderRadius: 12 }}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ))}

        {images?.length > 0 && images.map((data) => (
          <div className="file-picker-files-preview me-2 mb-2" key={data.id}>
            <img
              src={STORAGE_URL+data.path}
              alt={`Preview ${data.id}`}
              className="border"
              style={{ maxWidth: 200, maxHeight: 150, display: 'block', objectFit: 'cover' }}
            />

            <IoMdClose
              className="file-picker-files-preview-close"
              size={20}
              onClick={() => onRemove(data.id, data.path)}
              style={{ cursor: 'pointer' }}
            />
          </div>
        ))}
      </div>
    </>
  );
}

export default FilePicker;